import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, Input, Label } from 'reactstrap'
import DatePicker from 'react-datepicker'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import Select from '../../../components/Template/Input/Select'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import AddFiles from '../../../components/Template/Files/AddFiles'
import { listProjects } from '../../../store/ducks/technicalDep'
import { graphClient } from '../../../store/sagas/auth'
import { notifyError } from '../../../utils/notify'
import Button from 'reactstrap/lib/Button'
import oikosApi from '../../../services/oikos'

class Payments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      description: null,
      date: null,
      value: null,
      type: null,
      paymentIsForMe: true,
      project: null,
      person: null,

      getProjectsIsLoading: false,
      projects: [],

      getIndividualsIsLoading: false,
      individuals: [],

      handleSubmitIsLoading: false,
    }

    this.filesRef = React.createRef()
  }

  componentDidMount() {
    this.getProjects()
    this.getIndividuals()
  }

  getProjects = async () => {
    try {
      this.setState({ getProjectsIsLoading: true })
      const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,77161ad8-7adf-4b56-bffe-f28807248097'
      const listId = '1d6e45f6-f132-4223-9fbe-6de7ecb2439d'
      const endpoint = `sites/${siteId}/lists/${listId}/items/?expand=fields`
      const res = await graphClient.api(endpoint).get()

      console.tron.log('lista projetos sharepoint res', res.value)
      this.setState({
        getProjectsIsLoading: false,
        projects: res.value,
      })
    } catch (e) {
      notifyError('Erro ao buscar projetos.')
      console.tron.log('Erro ao buscar projetos.', e.toString())
    }
  }

  getIndividuals = async () => {
    try {
      this.setState({ getIndividualsIsLoading: true })

      const res = await oikosApi.get('/', {
        table: 'pf',
        action: 'get',
      })

      console.tron.log('res getIndividuals', res)

      this.setState({
        getIndividualsIsLoading: false,
        individuals: res.data,
      })
    } catch (e) {
      notifyError('Erro ao buscar pessoas físicas.')
      console.tron.log('Erro ao buscar pessoas físicas.', e.toString())
    }
  }

  handleSubmit = async () => {
    try {
      const {
        description, date, value, type, paymentIsForMe,
        getProjectsIsLoading, projects, project, person,
      } = this.state

      const item = {
        fields: {
          Descri_x00e7__x00e3_o: description,
          Valor: Number(value),
          Data: date,
          Tipos: type?.label,
          Consultor: person,
          ProjetoLookupId: project?.id,
        },
      }
      console.tron.log('item', item)

      const files = this.filesRef?.current?.state?.files
      console.tron.log('files', files)

      const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,77161ad8-7adf-4b56-bffe-f28807248097'
      const listId = 'ec552e78-d873-404f-8840-aeb5b3549a4d'

      const attachment = {
        '@odata.type': '#microsoft.graph.fileAttachment',
        name: 'smile',
        contentBytes: 'R0lGODdhEAYEAA7',
      }

      const resAttachment = await graphClient
        .api(`/sites/${siteId}/lists/${listId}/items/175/attachments`)
        .post(attachment)

      console.tron.log('resAttachment', resAttachment)

      // const res = await graphClient
      //   .api(`/sites/${siteId}/lists/${listId}/items`)
      //   .post(item)

      // console.tron.log('res', res)
    } catch (error) {
      notifyError('Erro ao enviar solicitação de pagamento.')
      console.tron.log('Erro ao enviar solicitação de pagamento.', error.toString())
    }
  }

  render() {
    const {
      description, date, value, type, paymentIsForMe,
      getProjectsIsLoading, projects, project, person,
      getIndividualsIsLoading, individuals,
    } = this.state

    const { user } = this.props.auth

    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Solicitação de pagamento"
            breadcrumbItems={[]}
          />

          <Row>
            <Col>
              <Label>
                Projeto
              </Label>
              <Select
                isLoading={getProjectsIsLoading}
                isDisabled={getProjectsIsLoading}
                placeholder="Projeto"
                options={projects}
                value={project}
                onChange={project => this.setState({ project })}
                getOptionValue={option => option.id}
                getOptionLabel={option => option.fields.cjiq}
              />
            </Col>

            <Col>
              <Label>
                Pessoa física
              </Label>
              <Select
                isLoading={getIndividualsIsLoading}
                isDisabled={getIndividualsIsLoading}
                options={individuals}
                value={person}
                onChange={person => this.setState({ person })}
                getOptionValue={option => option.pf_id}
                getOptionLabel={option => option.pf_nomeExibicao}
              />
            </Col>

            <Col>
              <Label>
                Tipo de solicitação
              </Label>
              <Select
                isSearchable
                isClearable
                isMulti={false}
                value={type}
                onChange={type => this.setState({ type })}
                options={[
                  {
                    label: 'Adiantamento de campo',
                    value: 'Adiantamento de campo',
                  },
                  {
                    label: 'Reembolso',
                    value: 'Reembolso',
                  },
                  {
                    label: 'ART',
                    value: 'ART',
                  },
                  {
                    label: 'Outro',
                    value: 'Outro',
                  },
                ]}
              />
            </Col>

            <Col>
              <Label>
                Valor
              </Label>
              <MaskedInput
                unmask
                inputRef={el => this.input = el}
                mask="R$ num"
                lazy={false}
                blocks={{
                  num: {
                    mask: Number,
                    scale: 2, // digits after point 0 for integers
                    signed: false, // disallow negative
                    thousandsSeparator: '.', // any single char
                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                    normalizeZeros: false, // appends or removes zeros at ends
                    radix: ',', // fractional delimiter
                    min: 0,
                    max: 1000000000,
                  },
                }}
                value={value}
                onAccept={value => this.setState({ value })}
              />
            </Col>

            <Col>
              <Label>
                Data de pagamento
              </Label>
              <DatePicker
                locale="pt-BR"
                className="form-control"
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                selected={date}
                onChange={date => this.setState({ date })}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Label>
                Nome do favorecido
              </Label>

              <Input
                value={person?.pf_nomeExibicao}
                // onChange={e => this.setState({ person: e?.target?.value })}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Label>
                Descrição
              </Label>
              <Input
                type="textarea"
                rows={3}
                value={description}
                onChange={e => this.setState({ description: e.target.value || null })}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Label>
                Anexos
              </Label>
              <AddFiles
                ref={this.filesRef}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Button
                color="primary"
                onClick={() => this.handleSubmit()}
              >
                Enviar
              </Button>
            </Col>
          </Row>
        </Container>
      </div>

    )
  }
}

const mapStateToProps = state => ({ auth: state.auth, technicalDep: state.technicalDep })
const mapDispatchToProps = dispatch => bindActionCreators({
  listProjects,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Payments)
